angular.module('zc')
  .component('zcIwItems', {
    templateUrl: '/templates/projects.iw/iw_items.html',
    bindings: {
      project: '<'
    },
    controller: zcIwItemsController
  });

zcIwItemsController.$inject = ['$scope', '$translate', 'Page', 'SearchFilter', 'InterestWidgetItem'];
function zcIwItemsController($scope, $translate, Page, SearchFilter, InterestWidgetItem) {
  const vm = this;

  const CSV_HEADERS = [
    { name: 'title', title: $translate.instant('projectsIw.items.title') },
    { name: 'url', title: $translate.instant('projectsIw.items.url') },
    { name: 'thumbnail_url', title: $translate.instant('projectsIw.items.thumbnailUrl') },
    { name: 'price', title: $translate.instant('projectsIw.items.price') },
    { name: 'item_count', title: $translate.instant('projectsIw.items.itemCount') },
    { name: 'iw_item_count', title: $translate.instant('projectsIw.items.iwItemCount') },
    { name: 'iw_item_rate', title: $translate.instant('projectsIw.items.iwItemRate') }
  ];

  Page.setBodyClass('');
  $translate('projectsIw.items.deliveryStatus').then(function(translation) {
    Page.setTitle(translation);
  });

  vm.filters = SearchFilter.resolveFromLocation({
    start_at: moment().startOf('month'),
    end_at: moment().endOf('day')
  });

  vm.csvHeaders = _.map(CSV_HEADERS, 'title');
  vm.csvHeaderNames = _.map(CSV_HEADERS, 'name');

  vm.page = 1;
  vm.itemsPerPage = 10;
  vm.beginItem = 0;

  vm.pageChanged = pageChanged;
  vm.getCSV = getCSV;
  vm.updateFilters = updateFilters;
  vm.resetFilters = resetFilters;

  vm.$onInit = () => {
    vm.updateFilters();
    $scope.$on('destroy', destroy);
  };

  function updateFilters() {
    let device = ((vm.filters.device_value) ? vm.filters.device_value.name : null);
    if(device === 'pc') {
      device = { $in: ['pc', 'tablet'] };
    } else if(device === 'sp') {
      device = 'sp';
    }
    const campaignSegmentId = ((vm.filters.campaign_segment_value) ? vm.filters.campaign_segment_value.id : null);
    _.merge(vm.filters, {
      device: device,
      campaign_segment_id: campaignSegmentId,
      start_at: vm.filters.start_at,
      end_at: vm.filters.end_at
    });
    SearchFilter.set(vm.filters);
    updateData();
  }

  function pageChanged() {
    vm.beginItem = (vm.page - 1) * vm.itemsPerPage;
  }

  function getCSV() {
    return _.map(vm.items, item => _.pick(item, vm.csvHeaderNames));
  }

  function updateData() {
    SearchFilter.updateComponentDefaults('zcIwItems');
    InterestWidgetItem.rankByFilters(vm.project.apikey, vm.filters)
      .then(items => {
        vm.items = items;
      });
  }

  function resetFilters() {
    SearchFilter.resetComponentDefaults('zcIwItems');
  }

  function destroy() {
    SearchFilter.removeComponentDefaults('zcIwItems');
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_items.js